import { format, isSameDay, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { Slot, SlotsItem } from '@/types';

export const filterSelectedDateFromSlots = (slots: SlotsItem[], selectedDate: Date | undefined) => {
  if (!selectedDate) return { date: 'No slot has been selected', availableSlots: [] };
  const selectedSlot = slots.filter((slot) => {
    if (isSameDay(slot.date, format(selectedDate, 'yyyy-MM-dd'))) return slot;
  });
  if (selectedSlot.length === 0)
    return { date: format(selectedDate, 'yyyy-MM-dd'), availableSlots: [] };
  return selectedSlot[0];
};

export const getDaysWithNoSlotsAvailable = (slotsData: SlotsItem[]) => {
  return slotsData
    .filter((slot) => slot.availableSlots.length === 0)
    .map((slot) => parseISO(slot.date));
};

export const retrieveFormattedSlotHour = (slot: Slot | null, timezone: string) => {
  if (!slot) return '';
  return formatInTimeZone(new Date(slot.utcStart * 1000), timezone, 'hh:mm a');
};

export const retrieveFormattedSlotDate = (slot: Slot | null, timezone: string) => {
  if (!slot) return '';
  return formatInTimeZone(new Date(slot.utcStart * 1000), timezone, 'yyyy-MM-dd');
};

export const getFormattedSlotDate = (date: Date, timezone: string) => {
  if (!date || isNaN(date.getTime())) return null;
  return formatInTimeZone(new Date(date), timezone, 'yyyy-MM-dd');
};

export const getSlotHour = (date: Date, timezone: string) => {
  if (!date || isNaN(date.getTime())) return null;
  return formatInTimeZone(new Date(date.setMinutes(0, 0, 0)), timezone, 'hh:mm a');
};

export const getSlotHourOnly = (slot: Slot | null, timezone: string) => {
  if (!slot) return '';
  return formatInTimeZone(new Date(slot.utcStart * 1000).setMinutes(0), timezone, 'hh:mm a');
};

export const getAvailableSlotsForDate = (slots: SlotsItem[], selectedDate: Date) => {
  const slot =
    slots.find((slot) => slot.date === format(selectedDate, 'yyyy-MM-dd'))?.availableSlots || [];

  return {
    slot: slot,
    isAvailable: slot && slot.length > 0,
  };
};
